import "./src/styles/fonts.css";
import "./src/styles/fx-tokens.css";
import "./src/styles/site.css";
import "./src/styles/global.css";

import { initCursor } from "./src/lib/cursor";

export const onClientEntry = () => {
  // One persistent canvas on <body>; survives route changes.
  initCursor();
};
